var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPytorch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.7 4.4L33.4 33.7c-16.2 16.2-16.2 42.5 0 58.7 16.2 16.2 42.5 16.2 58.7 0 16.2-16.2 16.2-42.5 0-58.7l-7.1 7.1c12.3 12.3 12.3 32.2 0 44.5-12.3 12.3-32.2 12.3-44.5 0-12.3-12.3-12.3-32.2 0-44.5l22-22 .2-.2V4.4z",
    fill: "#EE4C2C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82.5,
    cy: 29.5,
    r: 6.5,
    fill: "#EE4C2C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPytorch);
export default __webpack_public_path__ + "static/media/pytorch.ea868fe4120166ce37eb3192ee6e169a.svg";
export { ForwardRef as ReactComponent };